// Function to format seconds into mm:ss format
export const formatTime = (timeInSeconds: number) => {
  if (timeInSeconds <= 0) {
    return "00:00";
  }
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// export function formatDateTime(timestampString: string) {
//   // Convert the timestamp string to a number
//   const timestamp = parseInt(timestampString);

//   // Create a Date object with the timestamp
//   const date = new Date(timestamp);

//   // Get the month, day, year, hours, and minutes
//   const month = date.toLocaleDateString("en-US", { month: "short" });
//   const day = date.getDate();
//   const year = date.getFullYear();
//   let hours = date.getHours();
//   const minutes = date.getMinutes();

//   // Convert hours to 12-hour format and get AM/PM
//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12;
//   hours = hours ? hours : 12; // Handle midnight (0 hours)

//   // Format the time
//   const time =
//     hours.toString().padStart(2, "0") +
//     ":" +
//     minutes.toString().padStart(2, "0") +
//     ampm;

//   // Construct the object with date and time properties
//   const formattedDateTime = {
//     date: `${month} ${day}, ${year}`,
//     time: `${hours}:${minutes}${ampm}`,
//   };

//   return formattedDateTime;
// }

export function formatDateTime(timestampString: string) {
  const timestamp = parseInt(timestampString);

  const date = new Date(timestamp);

  const month = date.toLocaleDateString("en-US", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedHours = hours.toString().padStart(2, "0");

  const time = `${formattedHours}:${minutes.toString().padStart(2, "0")}${ampm}`;

  // Construct the object with date and time properties
  const formattedDateTime = {
    date: `${month} ${day}, ${year}`,
    time: time,
  };

  return formattedDateTime;
}

// Example usage:
const timestampString = "1711388250613";
const formattedDateTime = formatDateTime(timestampString);
console.table(formattedDateTime); // Output: { date: "Feb 18, 2024", time: "06:20PM" }
